import { SET_PROFILE, SET_USER_ROUTE } from "./actionTypes";

const INIT_STATE = {
  user: null,
};

const customProfile = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_PROFILE:
      return { ...state, user: action.payload.info };
    default:
      return state;
  }
};

export default customProfile;
